import React from 'react';
import { INSURANCE_LINES } from './insuranceLines';

// Insurance-line multi-select (spec Section 1). Controlled component: pass
// `value` (array of line ids) + `onChange(nextArray)`. Supports one, several,
// or ALL lines, plus a Select-all / Clear-all affordance. Self-contained (no
// app state) so it drops into the onboarding wizard and Settings alike.
export default function InsuranceLinesStep({ value = [], onChange = () => {} }) {
  const selected = new Set(value);
  const allIds = INSURANCE_LINES.map((l) => l.id);
  const allSelected = allIds.every((id) => selected.has(id));

  const emit = (nextSet) => onChange(allIds.filter((id) => nextSet.has(id)));
  const toggle = (id) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id); else next.add(id);
    emit(next);
  };
  const toggleAll = () => onChange(allSelected ? [] : allIds.slice());

  return (
    <div className="space-y-3">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-bold text-slate-900">Which insurance do you sell?</h3>
          <p className="text-xs text-slate-500 mt-0.5">
            Pick one, several, or all. We'll tailor your CRM to just these lines — you can add more later.
          </p>
        </div>
        <button
          type="button"
          onClick={toggleAll}
          className="text-xs font-semibold text-amber-700 hover:text-amber-900 underline whitespace-nowrap mt-0.5"
        >
          {allSelected ? 'Clear all' : 'Select all'}
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {INSURANCE_LINES.map((l) => {
          const on = selected.has(l.id);
          return (
            <button
              key={l.id}
              type="button"
              onClick={() => toggle(l.id)}
              aria-pressed={on}
              className={`text-left rounded-xl border-2 px-3.5 py-3 transition focus:outline-none focus:ring-2 focus:ring-amber-400 ${
                on ? 'border-amber-500 bg-amber-50' : 'border-slate-200 bg-white hover:border-slate-300'
              }`}
            >
              <div className="flex items-center gap-2">
                <span
                  aria-hidden="true"
                  className={`w-4 h-4 rounded flex items-center justify-center text-[10px] font-black ${
                    on ? 'bg-amber-500 text-white' : 'bg-slate-200 text-transparent'
                  }`}
                >
                  ✓
                </span>
                <span className="font-semibold text-sm text-slate-900">{l.label}</span>
              </div>
              <div className="text-[11px] text-slate-500 mt-1 ml-6 leading-snug">{l.blurb}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
